import { ServerVariableObjectSchema as OriginalServerVariableObjectSchema } from '../processed/server-variable-object'

/**
 * Server Variable Object
 *
 * An object representing a Server Variable for server URL template substitution.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.1.md#server-variable-object
 */
export const ServerVariableObjectSchema = OriginalServerVariableObjectSchema
